<template>
  <div class="table-page">
    <search-wrapper>
      <a-row :gutter="20">
        <a-col :span="6" :xs="24" :sm="24" :md="24" :lg="20" :xl="11" :xxl="8">
          <a-form-item label="API接口">
            <a-cascader :options="options" :value="cascaderTarget" @change="handleCascaderChange" placeholder="全部类型/全部接口"></a-cascader>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xs="24" :sm="24" :md="24" :lg="20" :xl="11" :xxl="8">
          <a-form-item label="调用时间">
            <a-range-picker :allowClear="false" v-model="dateRange" format="YYYY-MM-DD HH:mm:ss" showTime style="width:: 100%">
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </a-form-item>
        </a-col>
        <a-col :span="6" :xs="24" :sm="24" :md="24" :lg="20" :xl="11" :xxl="8">
          <a-form-item class="operation-group">
            <a-button icon="search" @click="handleSearch">查询</a-button>
            <a-button class="reset-btn" icon="sync" @click="resetSearch">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </search-wrapper>
    <!-- 分页表格 -->
    <global-table
      ref="table"
      :columns="columns"
      :dataRender="loadData"
      style="margin-top: 24px"
      filled
    >
      <template v-slot:apiName="{ row, column, index }">
        <div style="width: 75%;float: left">
          <a-tooltip>
            <template slot="title">
              {{ row.apiName }}
            </template>
            <div style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;display: block">
              {{ row.apiName }}
            </div>
          </a-tooltip>
        </div>
        <div style="float: right;width: 20%">
          <a-icon style="color:#178FFF;" type="copy" @click="handleCopy(row.apiName)" />
        </div>
      </template>
      <template v-slot:command="{ row, column, index }">
        <div style="width: 75%;float: left">
          <a-tooltip>
            <template slot="title">
              {{ row.command }}
            </template>
            <div style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;display: block">
              {{ row.command }}
            </div>
          </a-tooltip>
        </div>
        <div style="float: right;width: 20%">
          <a-icon style="color:#178FFF;" type="copy" @click="handleCopy(row.command)" />
        </div>
      </template>
      <template v-slot:args="{ row, column, index }">
        <div style="width: 75%;float: left">
          <a-tooltip>
            <template slot="title">
              {{ row.args }}
            </template>
            <div style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;display: block">
              {{ row.args }}
            </div>
          </a-tooltip>
        </div>
        <div style="float: right;width: 20%">
          <a-icon style="color:#178FFF;" type="copy" @click="handleCopy(row.args)" />
        </div>
      </template>
      <template v-slot:message="{ row, column, index }">
        <div style="width: 75%;float: left">
          <a-tooltip>
            <template slot="title">
              {{ row.message }}
            </template>
            <div style="overflow: hidden;text-overflow: ellipsis;white-space:nowrap;display: block">
              {{ row.message }}
            </div>
          </a-tooltip>
        </div>
        <div style="float: right;width: 20%">
          <a-icon style="color:#178FFF;" type="copy" @click="handleCopy(row.message)" />
        </div>
      </template>
    </global-table>
  </div>
</template>

<script>
import moment from 'moment';
import {
  Button, Row, Col, Form, DatePicker, Cascader, Tooltip,
} from 'ant-design-vue';
import SearchWrapper from '@/components/SearchWrapper';
import GlobalTable from '@/components/GlobalTable';
import { getApiCascader, getErrorLogListByPage } from '@/services/modules/my-system';

export default {
  name: 'ErrorLog',
  components: {
    SearchWrapper,
    GlobalTable,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-form-item': Form.Item,
    'a-range-picker': DatePicker.RangePicker,
    'a-cascader': Cascader,
    'a-tooltip': Tooltip,
  },
  data() {
    return {
      options: [],
      dateRange: this.getInitDateRange(),
      cascaderTarget: [],
    };
  },
  mounted() {
    this.requestApiCascader();
  },
  computed: {
    columns() {
      return [
        {
          title: '调用时间',
          key: 'logTime',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '接口名称',
          key: 'apiName',
          align: 'left',
          minWidth: 125,
          slot: 'apiName',
        },
        {
          title: '请求地址',
          key: 'command',
          align: 'left',
          minWidth: 125,
          slot: 'command',
        },
        {
          title: '请求参数',
          key: 'args',
          align: 'left',
          minWidth: 125,
          slot: 'args',
        },
        {
          title: '错误码',
          key: 'errorCode',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '错误信息',
          key: 'message',
          align: 'left',
          minWidth: 125,
          slot: 'message',
        },
      ];
    },
    defaultQueryParams() {
      return {
        beginTime: this.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
        apiCategory: (this.cascaderTarget && this.cascaderTarget.length > 0) ? this.cascaderTarget[0] : '',
        apiId: (this.cascaderTarget && this.cascaderTarget.length > 1) ? this.cascaderTarget[1] : '',
      };
    },
  },
  methods: {
    loadData(parameter) {
      return getErrorLogListByPage({ ...parameter, ...this.defaultQueryParams });
    },
    requestApiCascader() {
      getApiCascader().then((res) => {
        if (res && res.result && res.result.length > 0) {
          this.options = res.result;
        }
      });
    },
    handleCascaderChange(value) {
      this.cascaderTarget = value;
    },
    handleSearch() {
      this.$refs.table.refresh(true);
    },
    resetSearch() {
      this.cascaderTarget = [];
      this.dateRange = this.getInitDateRange();
      this.handleSearch();
    },
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: moment().startOf('day').subtract(7, 'days'),
        endDate: moment().startOf('day').add(1, 'days').subtract(1, 'seconds'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    handleCopy(value) {
      this.$copyText(value).then(this.$message.success('复制成功'));
    },
  },
};
</script>

<style lang="less" scoped>
  .table-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .ant-col-8 {
      width: auto;
    }
    /deep/ .ant-col-6 {
      width: auto;
    }
    &__main {
       flex: 1;
       height: 100%;
    }
  }
</style>
